import React from 'react';

import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { MoreArticlesListProps } from './types';
import {
  ArticleContentComponent,
  ArticleDateTypography,
  ArticleItem,
  ArticleSummaryAndLinkContainer,
  ArticleTitleTypography,
  MoreArticlesContainer,
  MoreArticlesHeader,
  ReadMoreLink,
} from './styles';
import { NewsItem } from '../../../../pages/Home/types';
import {
  formatDate,
  mapLocaleAccordingToNzRules,
} from '../../../../helpers/localeFormatter';

const MoreNewsList: React.FC<MoreArticlesListProps> = ({
  countryIsoCode,
  articles,
  onReadMore,
}) => {
  const { t } = useI18n();
  const mappedCountry = mapLocaleAccordingToNzRules(countryIsoCode);

  const handleReadMoreClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    article: NewsItem
  ) => {
    event.preventDefault();
    onReadMore(article);
  };

  return (
    <MoreArticlesContainer>
      <MoreArticlesHeader>
        {t(TranslationKeys.homeNews_more_news)}
      </MoreArticlesHeader>
      {articles.map((article) => (
        <ArticleItem key={article.guid}>
          <ArticleContentComponent>
            <ArticleDateTypography>
              {formatDate(article.pubDate, mappedCountry)}
            </ArticleDateTypography>
            <ArticleTitleTypography>{article.title}</ArticleTitleTypography>
            <ArticleSummaryAndLinkContainer>
              <div
                dangerouslySetInnerHTML={{
                  __html: article.description?.['$cdata_section'] ?? '',
                }}
              />
              <ReadMoreLink
                href="#"
                onClick={(event) => handleReadMoreClick(event, article)}
              >
                {t(TranslationKeys.homeNews_read_more)}
              </ReadMoreLink>
            </ArticleSummaryAndLinkContainer>
          </ArticleContentComponent>
        </ArticleItem>
      ))}
    </MoreArticlesContainer>
  );
};

export default MoreNewsList;
